import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const SuctionGroupGlyph = /*#__PURE__*/createElement("g", {
  id: "suction_group"
}, /*#__PURE__*/createElement("path", {
  d: "M33.05 40.28v5.92l1.12.9a6.518 6.518 0 012.46 5.11c0 3.61-2.94 6.55-6.55 6.55s-6.55-2.94-6.55-6.55c0-1.99.9-3.85 2.46-5.11l1.12-.9v-5.92h5.94m3-3H24.12v7.48a9.524 9.524 0 00-3.58 7.45c0 5.27 4.27 9.55 9.55 9.55s9.55-4.27 9.55-9.55c0-3.01-1.4-5.7-3.58-7.45v-7.48h-.01z"
}), /*#__PURE__*/createElement("path", {
  d: "M25.71 43.44H22.8c-1.71 0-3.1-1.39-3.1-3.1V29.75h3v10.58c0 .05.04.1.1.1h2.91v3.01zm42.1-18.19h-28.9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5h28.9c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5z"
}), /*#__PURE__*/createElement("path", {
  d: "M37.31 43.44H34.4v-3h2.91a.1.1 0 00.1-.1V23.75h3v16.58c0 1.72-1.39 3.11-3.1 3.11zm19.54-3.16v5.92l1.12.9a6.518 6.518 0 012.46 5.11c0 3.61-2.94 6.55-6.55 6.55s-6.55-2.94-6.55-6.55c0-1.99.9-3.85 2.46-5.11l1.12-.9v-5.92h5.94m3-3H47.92v7.48a9.524 9.524 0 00-3.58 7.45c0 5.27 4.27 9.55 9.55 9.55s9.55-4.27 9.55-9.55c0-3.01-1.4-5.7-3.58-7.45v-7.48h-.01z"
}), /*#__PURE__*/createElement("path", {
  d: "M61.11 43.44H58.2v-3h2.91a.1.1 0 00.1-.1V23.75h3v16.58c0 1.72-1.39 3.11-3.1 3.11zm-12.59 0h-1.91c-1.71 0-3.1-1.39-3.1-3.1v-9.08H16.19c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5h27.82a2.5 2.5 0 012.5 2.5v9.58c0 .05.04.1.1.1h1.91c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5z"
}));
const SuctionGroup = createSvg({
  name: 'suction_group',
  path: SuctionGroupGlyph
});

export default SuctionGroup;
export { SuctionGroupGlyph };
